import * as React from 'react';

import { RespondButton } from '@/components/Post/components/RespondButton';
import { MessageCircleIcon } from '@/imports/ui/chakra/feather';

export const ReplyButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <RespondButton
      onClick={onClick}
      color="gray.600"
      size="sm"
      leftIcon={<MessageCircleIcon />}
    >
      Reply
    </RespondButton>
  );
};
